// Initialize vanilla-tilt on hero image with glare effect
// Respects prefers-reduced-motion for accessibility

import VanillaTilt from 'vanilla-tilt';

function initHeroTilt() {
  // Check for prefers-reduced-motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return; // Skip initialization if user prefers reduced motion
  }

  // Find all hero image containers
  const heroImages = document.querySelectorAll('.gh-hero-image');
  
  if (!heroImages || heroImages.length === 0) {
    return; // Hero images not found, exit gracefully
  }

  // Initialize tilt for each hero image
  heroImages.forEach((heroImage) => {
    // Check if tilt effect is enabled via theme setting
    const tiltEnabled = heroImage.getAttribute('data-tilt-enabled');
    // Handle string "true"/"false" or empty/undefined (defaults to enabled if not set)
    if (tiltEnabled === 'false' || tiltEnabled === false) {
      return; // Tilt effect disabled in theme settings for this image
    }

    // Initialize vanilla-tilt with glare enabled (subtle settings)
    VanillaTilt.init(heroImage, {
      max: 8,               // Max tilt rotation (degrees) - reduced for subtlety
      speed: 500,           // Speed of transition - slightly slower for smoother effect
      glare: true,          // Enable glare effect
      'max-glare': 0.4,     // Max glare opacity (0-1) - increased for more visible effect
      scale: 1.02,          // Scale on hover - reduced for subtlety
      perspective: 1000,    // Transform perspective
      easing: 'cubic-bezier(.03,.98,.52,.99)',
      reverse: false,       // Reverse tilt direction
      reset: true           // Reset on mouse leave
    });
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroTilt);
} else {
  // DOM already loaded
  initHeroTilt();
}

export default initHeroTilt;

